<!--
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-14 17:55:36
-->

<template>
  <page-header-wrapper>
    <div slot="extra">
      <a-button type="primary" icon="upload" v-action:import @click="handleBulkImport">批量导入</a-button>
    </div>
    <a-card>
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <standard-form-row>
            <div class="ant-pro-page-header-search">
              <a-input-search
                size="large"
                style="width: 80%; max-width: 522px;"
                v-model="params.where.code"
                placeholder="请输入要筛选的考试码"
                enter-button
                allow-clear
                @search="getLists()"
              />
              <a-button type="link" @click="() => (this.search = !this.search)">
                高级筛选
                <a-icon :type="search ? 'up' : 'down'" />
              </a-button>
            </div>
          </standard-form-row>
          <template v-if="search">
            <a-spin :spinning="searchLoading">
              <a-row :gutter="48">
                <a-col :md="12" :sm="24">
                  <a-form-item label="证书">
                    <a-spin :spinning="crtsLoad">
                      <a-select
                        allow-clear
                        placeholder="请选择要筛选的证书"
                        mode="multiple"
                        name="crt_id"
                        optionFilterProp="children"
                        v-model="params.where.crt_id"
                        @change="value => handleSelectChange(value, { name:'crtsList' })"
                      >
                        <a-select-option
                          v-for="item in crtsList"
                          :key="item.id"
                          :disabled="item.disabled"
                        >
                          {{ item.title }}
                        </a-select-option>
                      </a-select>
                    </a-spin>
                  </a-form-item>
                </a-col>
                <a-col :md="12" :sm="24">
                  <a-form-item label="考试模式">
                    <a-spin :spinning="modesLoad">
                      <a-select
                        allow-clear
                        mode="multiple"
                        optionFilterProp="children"
                        v-model="params.where.mode_id"
                        @change="value => handleSelectChange(value, { name:'modesList' })"
                        placeholder="请选择考试模式"
                      >
                        <a-select-option
                          v-for="item in modesList"
                          :key="item.id"
                          :disabled="item.disabled"
                        >
                          {{ item.name }}
                        </a-select-option>
                      </a-select>
                    </a-spin>
                  </a-form-item>
                </a-col>
                <a-col :md="12" :sm="24">
                  <a-form-item label="使用状态">
                    <a-select
                      allow-clear
                      placeholder="请选择"
                      @change="getLists()"
                      v-model="params.where.state"
                    >
                      <a-select-option value="">全部</a-select-option>
                      <a-select-option value="1">未使用</a-select-option>
                      <a-select-option value="2">已使用</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="12" :sm="24">
                  <a-form-item label="下单时间">
                    <a-range-picker
                      :ranges="{
                        最近七天: [moment().subtract('days', 6), moment()],
                        今天: [moment(), moment()],
                        本月: [moment().startOf('month'), moment()]
                      }"
                      :placeholder="['开始日期', '结束日期']"
                      @change="value => handleChangeDate(value)"
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="12" :lg="8" :sm="24">
                  <a-form-item label="批次">
                    <a-input
                      v-model="params.where.batch"
                      allow-clear
                      @pressEnter="getLists()"
                      placeholder="请输入要搜索的批次号"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </a-spin>
          </template>
        </a-form>
      </div>
    </a-card>
    <a-card style="margin-top: 24px" :bordered="false">
      <div class="table-operator">
        <table-tool-bar-list
          :columns="settingColumns"
          :element="element"
          @change="toolBarChange"
          @reload="getLists()"
          class="mr-4"
        />
        <export
          :columns="columns"
          :params="params"
          :url="apiList.getList"
          xlsxName="订单列表"
          v-action:export
          @click="getExportData"
        />
        <a-dropdown :disabled="selectedRowKeys.length === 0">
          <a-menu slot="overlay">
            <a-menu-item v-action:delete @click="handleTranslate">
              <a-icon type="share-alt" />批量转移
            </a-menu-item>
            <a-menu-item v-action:update>
              <a-popconfirm
                title="确认删除？"
                ok-text="是"
                cancel-text="否"
                @confirm="handleBatchesDelete()"
                v-action:delete
              >
                <a-icon type="delete" />批量删除
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
          <a-button>
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>

      </div>

      <a-table
        class="screenfull"
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :size="size"
        :bordered="false"
        :scroll="scroll"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
        <template slot="source_type" slot-scope="text">
          <a-tag v-if="text != undefined" :color="sourceTypeFilter(text).color">{{ sourceTypeFilter(text).value }}</a-tag>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a-popconfirm
            v-if="list.length"
            title="确定要删除吗？"
            @confirm="handleBatchesDelete(record.id)"
            v-action:delete
          >
            <a href="javascript:;"><a-icon type="delete" /> 删除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { table, list, select } from '@/mixins' // 引入
import { TableToolBarList, StandardFormRow, Export } from '@/components'

import { ImportForm, TranslateForm } from './modules'

const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        sorter: true
    },
    {
        title: '批次号',
        dataIndex: 'batch'
    },
    {
        title: '考试码',
        dataIndex: 'code'
    },
    {
        title: '到期日期',
        dataIndex: 'expire_date'
    },
    {
        title: '订单人',
        dataIndex: 'real_name'
    },
    {
        title: '状态',
        dataIndex: 'state'
    },
    {
        title: '订单日期',
        dataIndex: 'pay_at'
    },
    {
        title: '优惠码标题',
        dataIndex: 'coupon_title'
    },
    {
        title: '订单类型',
        dataIndex: 'source_type',
        align: 'center',
        scopedSlots: { customRender: 'source_type' }
    },
    {
        title: '活动',
        dataIndex: 'discount'
    },
    {
        title: '订单名称',
        dataIndex: 'title'
    },
    {
        title: '证书',
        dataIndex: 'certificate.title'
    },
    {
        title: '考试模式',
        dataIndex: 'mode.name'
    },
    {
        title: '导入日期',
        dataIndex: 'created_at'
    },
    {
        title: '订单编号',
        dataIndex: 'order.sn'
    },
    {
        title: '操作',
        dataIndex: 'operation',
        width: '100px',
        align: 'center',
        fixed: 'right',
        scopedSlots: { customRender: 'operation' }
    }
]

const apiList = {
    getList: '/certificates/codes',
    delete: '/certificates/codes',
    import: '/certificates/codes/import',
    warning: '/certificates/codes/warning',
    crtsSelect: '/certificates/select', // 获取证书下拉
    modesSelect: '/certificates/modes/select', // 获取模式下拉
    create: '/certificates/codes/create'
}

export default {
    name: 'CodesList',
    mixins: [table, list, select], // 使用mixins
    components: {
        ImportForm,
        TranslateForm,
        TableToolBarList,
        StandardFormRow,
        Export
    },
    data () {
        return {
            apiList,
            columns,
            settingColumns: JSON.parse(JSON.stringify(columns)), // 深度复制表头
            // 查询参数
            selectedRowKeys: [],
            selectedRows: [],
            searchLoading: false, // 证书下拉加载
            modesList: [], // 考试模式下拉数据
            modesLoad: false, // 考试模式下拉加载
            crtsList: [], // 分类下拉数据
            crtsLoad: false // 分类下拉加载
        }
    },
    computed: {
      sourceTypeFilter (status) {
            return function (status) {
                const statusMap = {
                    1: { value: '课程', color: 'pink' },
                    2: { value: '证书', color: 'red' },
                    3: { value: '套购', color: 'orange' }
                }
                return statusMap[status]
            }
        }
    },
    mounted () {
        this.getLists()
        this.getSelectLists({
            url: apiList.crtsSelect,
            type: 'crtsList',
            load: 'crtsLoad'
        })
        this.getSelectLists({
            url: apiList.modesSelect,
            type: 'modesList',
            load: 'modesLoad'
        })
    },
    methods: {
        getExportData (columns, data) {
          data.filter(item => {
                item.source_type = item.source_type ? this.sourceTypeFilter(item.source_type).value : ''
            })
            this.outputXlsxFile(columns, data, '**考试码列表' + this.moment(new Date()).format('YYYYMMDDHHmmss'))
        },
        /**
         * 列表选择
         * 获取选择的id数组及选择行数据
         * @jdy
         */
        onSelectChange (selectedRowKeys, selectedRows) {
            this.selectedRows = selectedRows
            this.selectedRowKeys = selectedRowKeys
        },
        /**
         * 点击批量导入弹窗口
         * @jdy
         * @2021-4-16
         */
        handleBulkImport () {
            const that = this
            that.$dialog(
                ImportForm,
                {
                    on: {
                        ok () {
                            that.getLists()
                        }
                    }
                },
                {
                    title: '批量导入',
                    centered: true,
                    okText: '导入',
                    cancelText: '关闭',
                    maskClosable: false
                }
            )
        },
        /**
         * 批量转移弹出层
         * @param
         * @jdy
         */
        handleTranslate () {
            const that = this
            that.$dialog(
                TranslateForm,
                {
                    ids: that.selectedRowKeys,
                    on: {
                        ok () {
                            that.selectedRowKey = []
                            that.getLists()
                        }
                    }
                },
                {
                    title: '批量转移',
                    centered: true,
                    okText: '转移',
                    cancelText: '取消',
                    maskClosable: false
                }
            )
        }
    }
}
</script>

<style lang="less" scoped>
.ant-pro-page-header-search {
    text-align: center;
    margin-bottom: 16px;
}
.table-operator {
    display: flex;
    justify-content: flex-end;
}
</style>
